
import {
    get,
    post,
    del,
    getfile
} from '@/http/request'
import {
    HOST
} from '@/http/config'


// 新增简报
export function addBriefing(params) {
    return post(`${HOST}briefing/save`, params)
}
// 修改简报
export function updateBriefing(params) {
    return post(`${HOST}briefing/update`, params)
}
//简报列表
export function getBriefing(params) {
    return get(`${HOST}briefing/list/`, params)
}
//报头
export function getSysHeader(params) {
    return get(`${HOST}sys-header/list`, params)
}
//简报列表
export function getUserIds() {
    return get(`${HOST}briefing/getUserIds`)
}
//简报草稿箱列表
export function BriefingDraftlist(params) {
    return get(`${HOST}briefing/draftlist`, params)
}
//简报详情
export function BriefingDetial(params) {
    return get(`${HOST}briefing/get/`, params)
}
// 删除简报
export function delBriefing(params) {
    return del(`${HOST}briefing/delete`, params)
}
// 通过id获取文件信息
export function createWord(id) {
    return get(`${HOST}briefing/createWord`, { id })
}

// 历史记录
export function getHistoryList(params) {
    return get(`${HOST}briefingHistory/list`, params)
}

// 历史记录详情
export function briefingHistoryGet(params) {
    return get(`${HOST}briefingHistory/get`, params)
}
// 浏览人
export function getPersonalCounts(params) {
    return get(`${HOST}briefing/getPersonalCounts`, params)
}






// WEBPACK FOOTER //
// ./src/views/BriefReport/api/api.js